export enum CONNECTION_TYPE {
  CABLE_WIFI = 'cable/wi-fi',
  CELLULAR = 'cellular',
}
